module.exports = __webpack_public_path__ + "img/Right_Sphere.5ea141b9.png";